import React, { useState } from 'react';

// Fixed offsets per depth, so the pile looks handled rather than generated.
const DEPTH = [
  { rotate: 0, x: 0, y: 0 },
  { rotate: -2.4, x: 7, y: 6 },
  { rotate: 2.8, x: -6, y: 11 },
  { rotate: -1.6, x: 3, y: 15 },
];

/**
 * A pile of prints: one on top, the rest showing their edges behind it.
 * Clicking sends the top one to the back, the way you go through a stack of
 * photographs. Enlarging is a separate, quieter control, so the two gestures
 * never fight over the same click.
 */
export default function PhotoStack({ photos, caption, onOpen, enlargeLabel = 'Enlarge' }) {
  const [top, setTop] = useState(0);
  const count = photos.length;

  if (count === 1) {
    return (
      <div className="stack is-single">
        <button
          type="button"
          className="stack-card"
          onClick={() => onOpen(0)}
          aria-label={`${caption} — enlarge`}
        >
          <img src={photos[0]} alt={caption} loading="lazy" decoding="async" />
        </button>
      </div>
    );
  }

  return (
    <div className="stack">
      <div className="stack-pile">
        {photos.map((src, i) => {
          const depth = (i - top + count) % count;
          const d = DEPTH[Math.min(depth, DEPTH.length - 1)];
          const isTop = depth === 0;
          return (
            <button
              type="button"
              key={src}
              className={`stack-card${isTop ? ' is-top' : ''}`}
              style={{
                transform: `translate(${d.x}px, ${d.y}px) rotate(${d.rotate}deg)`,
                zIndex: count - depth,
              }}
              tabIndex={isTop ? 0 : -1}
              aria-hidden={isTop ? undefined : true}
              onClick={() => setTop((t) => (t + 1) % count)}
              aria-label={`${caption} — photo ${top + 1} of ${count}, show next`}
            >
              <img src={src} alt={isTop ? caption : ''} loading="lazy" decoding="async" />
            </button>
          );
        })}
      </div>

      <p className="stack-bar">
        <span className="stack-count">
          {top + 1} / {count}
        </span>
        <button type="button" className="stack-enlarge" onClick={() => onOpen(top)}>
          {enlargeLabel}
        </button>
      </p>
    </div>
  );
}
